import React, { memo } from "react";

import type { IPTUBillingInfo } from "../../../hooks/reactQueryHooks/useBilling";
import { formatCurrency } from "../../../utils/NumbersFormatting";
import { Badge } from "../../Badge/Badge";
import { MoneyIcon } from "../../icons";
import { ArrowIcon } from "../../icons/ArrowIcon";

export interface BillingBadgePtuProps {
  billingData: IPTUBillingInfo;
  isStripe: boolean;
}

const BillingBadgePtu: React.FC<BillingBadgePtuProps> = memo(
  ({ billingData, isStripe }) => {
    return (
      <div className="sidebar-badge">
        <Badge
          variant="success"
          size="sm"
          content={{
            value: isStripe
              ? formatCurrency(billingData.credits || 0)
              : formatCurrency(billingData.amountDue || 0),
            title: isStripe ? "Credit balance" : "Amount due",
            rightItems: [
              {
                beforeIcon: (
                  <>
                    <MoneyIcon />
                    <ArrowIcon className="arrow" size={10} />
                  </>
                ),
                text: `${formatCurrency(
                  billingData?.tokenMetrics?.costSavings || 0,
                )}`,
                subtitle: "savings",
              },
            ],
          }}
        />
      </div>
    );
  },
);

export { BillingBadgePtu };
